"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Click here to expand the group members": "Klicken Sie hier, um die Gruppenmitglieder zu erweitern",
  "Click here to view the group members": "Klicken Sie hier, um die Gruppenmitglieder anzuzeigen",
  "Company, {company}": ["Unternehmen, ", ["company"]],
  "Contact card, {name}": ["Visitenkarte, ", ["name"]],
  "Department, {department}": ["Abteilung, ", ["department"]],
  "Email, {emailAddress}": ["E-Mail-Adresse, ", ["emailAddress"]],
  "Expand members": "Mitglieder erweitern",
  "Group - {members, plural, one {# member} other {# members}}": ["Gruppe – ", ["members", "plural", {
    one: ["#", " Mitglied"],
    other: ["#", " Mitglieder"]
  }]],
  "Mobile phone, {mobilePhone}": ["Mobiltelefon, ", ["mobilePhone"]],
  "Mobile: {mobilePhone}": ["Mobiltelefon: ", ["mobilePhone"]],
  "Name, {name}": ["Name, ", ["name"]],
  "Title, {title}": ["Titel, ", ["title"]],
  "Type to search": "Zum Suchen tippen",
  "View members": "Mitglieder anzeigen",
  "Work phone, {workPhone}": ["Telefon (Arbeit), ", ["workPhone"]],
  "Work: {workPhone}": ["Arbeit: ", ["workPhone"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map